import {comasToDots} from './comasToDots';
import {replaceAllButFirstOccurrence} from './replaceAllButFirstOccurrence';

export function replaceAllButFloat(
  value: string,
  options?: {allowNegative?: boolean},
): string {
  const {allowNegative = false} = options || {};

  const regex = allowNegative ? /[^-?\d.,]/g : /[^?\d.,]/g;
  const digitsAndDots = comasToDots(value.replace(regex, ''));

  const result = replaceAllButFirstOccurrence(digitsAndDots, /\./g, '');

  if (result === '.') {
    return '0.';
  }

  return result;
}
